// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**********************************************/
/**********************************************/

/* SECTION: INTRO */
.introSection {
  background-color: hsl(0, 0%, 98%);
  height: 100%;
}

.introContainer {
  padding: 4% 8% 8%;
}

.introImageWrapper {
  margin-top: 5%;
  border-radius: 2rem;
  overflow: hidden;
}

.catchphraseContainer {
  width: 100%;
}

.catchphrase {
  font-size: 2.1rem;
}

.introImage {
  width: 100%;
}

.searchBarContainer {
  width: 100%;
  height: 40px;
  color: hsl(0, 0%, 85%);
  padding: 8px 16px;
  margin: 8px 0;
  border: 1px solid hsl(0, 0%, 90%);
  border-radius: 8px;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  background-color: white;
  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.05),
    0 10px 10px rgba(0, 0, 0, 0.05);
}

.searchIcon {
  margin-right: 8px;
}

.mapLink {
  color: hsl(0, 0%, 65%);
  font-size: 1rem;
  transition: color 0.2s ease-in-out;
  padding-left: 4px;
}

.mapLink:hover {
  text-decoration: none;
  color: #16a29a;
}

.catchphraseHeader {
  font-size: 1.7rem;
  font-weight: 500;
  line-height: 1.2;
  max-width: 300px;
}

/****** Full Size Landing view Component ****/

@media screen and (min-width: 840px) {
  .introContainer {
    display: grid;
    grid-template-columns: 40% 60%;
    align-items: start;
    padding: 4% 8%;
    padding-right: 4%;
  }
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .catchphraseContainer {
    justify-content: column wrap;
  }

  .catchphrase {
    font-size: 2.1rem;
    flex-flow: column wrap;
    padding-top: 26%;
  }

  .introImageContainer {
    padding-left: 8%;
    display: flex;
    align-items: center;
  }

  .introImageWrapper {
    margin-top: 0;
  }

  .searchBarContainer {
    height: 50px;
    font-size: 1.7rem;
  }

  .mapLink {
    font-size: 1.2rem;
  }

  .catchphraseHeader {
    max-width: none;
  }
}

/**********************************************/
/**********************************************/

/* SECTION: MISSION */

.missionBody {
  padding: 16px 24px;
  align-items: center;
  background-color: #16a29a;
  margin: 8%;
}

.missionContent {
  display: grid;
  grid-template-columns: 100px auto;
  align-items: center;
  grid-gap: 16px;
  padding: 24px 0;

  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.missionImageContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.missionImage {
  width: 80px;
}

.missionContentText {
  margin-left: 16px;
}

.missionContentSubtitleText {
  font-size: 1.2rem;
  margin-top: 8px;
  color: white;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .missionBody {
    display: flex;
    justify-content: space-evenly;
    flex-flow: row wrap;
    align-items: flex-start;
    padding: 3% 4% 4%;
    margin: 5% 8%;
  }

  .missionContent {
    display: grid;
    grid-template-columns: none;
    grid-template-rows: 120px auto;
    align-items: center;
    grid-gap: 56px;
    padding-bottom: 0;
    text-align: center;
    width: auto;
    max-width: 28%;
    margin: unset;
  }

  .missionContentText {
    margin-left: 0;
  }

  .missionContentSubtitleText {
    font-size: 1.6rem;
    margin-top: 0;
    max-width: 285px;
  }
}

/**********************************************/
/**********************************************/

/* SECTION: CTA */

.landingCTAContainer {
  margin-bottom: 10px;
}

.mainCTASection {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 240px;
  background-color: #16a29a;
  padding: 8%;
}

.mainCTAContainer {
  min-width: 100%;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
}

.mainCTATitle {
  color: #ffffff;
  font-size: 1.7rem;
  margin-bottom: 16px;
  width: 240px;
  text-align: center;
}

.mainCTAAction {
  width: 100%;
}

.mainCTAText {
  color: white;
  font-size: 1.7rem;
}

.mainCTAText > a {
  color: white;
}

.mainCTAText > a:hover {
  color: hsl(0, 0%, 95%);
  text-decoration: none;
}

.formLabel,
.requiredFormLabel {
  display: block;
  margin-bottom: 4px;
  font-weight: normal;
}

.requiredFormLabel::after {
  content: ' *';
  color: #959595;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .landingCTAContainer {
    margin-bottom: 10px;
  }
  .mainCTASection {
    height: 350px;
    padding: 0;
    margin: 0 8% 6%;
  }

  .mainCTAContainer {
    min-width: 400px;
  }

  .mainCTATitle {
    font-size: 2.1rem;
    width: 100%;
  }

  .formLabel,
  .requiredFormLabel {
    margin: 8px 0;
    font-size: 1.8;
  }
}

/**********************************************/
/**********************************************/

/* SECTION: USERS */

.user,
.team {
  background-color: #f3f6f8;
}

.usersSection {
  background-color: white;
}

.userTitleText {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #12807a;
  color: white;
  font-size: 1.4rem;
  width: 100%;
}

/* EACH USER */

.usersContainer {
  display: none;
}

.usersContainerMobile {
  display: block;
  margin: 0 8% 8%;
}

.userContainer {
  display: flex;
  flex-flow: column wrap;
  padding: 8% 0;
}

.userImageContainer {
  width: 100%;
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  border-radius: 2rem;
  overflow: hidden;
}

.userBody {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
}

.userBodyLink:hover {
  text-decoration: none;
}

.userBodyContent {
  width: 100%;
}

.userTitle {
  color: white;
  font-size: 1.2rem;
  border-radius: 40px;
  border: 1px solid #16a29a;
  padding: 4px 16px;
  background-color: #16a29a;
}

.userTextHeader {
  font-size: 1.7rem;
  margin-bottom: 3rem;
}

.userTextBody {
  margin: 4px 0 16px;
  color: hsl(0, 0%, 10%);
}

.userTextList {
  list-style-type: none;
  margin-top: 12px;
  margin-bottom: 12px;
}

.userTextListWithDots {
  list-style-position: inside;
  margin-top: 12px;
  margin-bottom: 12px;
}

.catchphraseSubtitle {
  margin: 8px 0 16px;
  color: hsl(0, 0%, 10%);
  font-size: 1rem;

  background-color: rgba(255, 255, 250, 0.3);
  border-radius: 5px;
}

.arrowContainer {
  border-left: 1px solid #16a29a;
  margin-left: 8px;
  padding-left: 8px;
  display: flex;
  height: 100%;
}

.arrowContainer:hover {
  color: white;
}

/****** MQ Show Desktop Layout ******/
@media screen and (min-width: 64em) {
  .usersContainerMobile {
    display: none;
  }

  .usersContainer {
    display: block;
    padding-bottom: 80px;
    background-color: white;
  }

  .userContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 4% 8% 2%;
  }

  .userBodyContent {
    width: 80%;
  }

  .userTitle {
    font-size: 1.7rem;
    padding: 4px 28px;
  }

  .userTextHeader {
    font-size: 2.1rem;
    line-height: 1.2;
  }

  .userTextBody {
    font-size: 1.2rem;
    margin: 12px 0 24px;
  }

  .catchphraseSubtitle {
    font-size: 1.2rem;
    margin: 12px 0 24px;
    background: none;
  }
}

/**********************************************/
/**********************************************/

/* SECTION: PAGE HEADER */

.pageHeader {
  margin-top: 72px;
  padding: 6% 8%;
  background-color: #16a29a;
}

.pageHeaderSubtitle {
  font-size: 1rem;
  color: hsl(0, 0%, 95%);
  text-decoration: underline;
}

.pageHeaderUptitle {
  font-size: 1.7rem;
  font-weight: 500;
  margin-top: 0;
  color: white;
}

.pageHeaderTitle {
  font-size: 1.7rem;
  font-weight: 500;
  margin-top: 8px;
  color: white;
}

.pageHeaderTitleOnly {
  font-size: 1.7rem;
  font-weight: 500;
  color: white;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .pageHeaderSubtitle {
    font-size: 1.2rem;
  }

  .pageHeaderTitle {
    font-size: 2.5rem;
  }

  .pageHeaderTitleOnly {
    font-size: 3rem;
  }
}

/**********************************************/
/**********************************************/

/* SECTION: FOOTER */

.footerSection {
  padding: 8%;
  background-color: hsl(0, 0%, 98%);
}

.footerBodyContainer {
  display: flex;
  flex-flow: column wrap;
}

.companyInfoContainer {
  width: 250px;
}

.companyInfoTitle {
  font-size: 2.1rem;
  font-weight: 500;
  margin-bottom: 8px;
}

.footerLinkContainer {
  display: flex;
  margin-top: 24px;
}

.footerLinkColumns {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 12px;
  width: 100%;
}

.footerLinkGroup {
  display: grid;
}

.footerLinkTitle {
  font-weight: 700;
}

.footerBottomContainer {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid hsl(0, 0%, 90%);
}

.footerBottomCopyright {
  display: grid;
  grid-template-rows: auto auto auto;
  grid-gap: 4px;
}

.socialButtonsContainer {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 8px;
}

.textLink {
  color: hsl(0, 0%, 20%);
  transition: color 0.2s ease-in-out;
  cursor: pointer;
}

.textLink:hover {
  text-decoration: none;
  color: #16a29a;
}

.textLink:focus {
  text-decoration: none;
  color: hsl(0, 0%, 20%);
}

.underline {
  text-decoration: underline;
}

.footerContactButton {
  background-color: #16a29a;
  border-radius: 8px;
  color: white;
  padding: 5px 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  font-size: 0.9rem;
  font-weight: 500;
}

.footerContactButton:hover {
  background-color: #7fcbb4;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .footerSection {
    padding: 4% 8%;
  }

  .footerBodyContainer {
    display: grid;
    grid-template-columns: 2fr 1fr;
  }

  .footerLinkContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 0;
  }

  .footerLinkGroup {
    display: grid;
    grid-gap: 8px;
  }

  .footerBottomCopyright {
    display: grid;
    grid-template-rows: none;
    grid-template-columns: auto auto auto;
    grid-gap: 16px;
  }

  .footerContactButton {
    font-size: 1rem;
  }
}

/**********************************************/
/**********************************************/

/* PROMOTEURS */
/* SECTION: INTRO */
.userPageIntroSection {
  padding-top: 90px;
  background-color: hsl(0, 0%, 98%);
  height: 100vh;
}

.userPageHeader {
  width: 100%;
  padding: 8%;
}

.userPageSubtitle {
  color: #12807a;
  font-size: 1.2rem;
  width: fit-content;
  border: 1px solid #12807a;
  border-radius: 40px;
  padding: 4px 24px;
}

.userPageTitle {
  font-size: 1.7rem;
  margin: 24px 0 8px;
  line-height: 1.3;
}

.userPageIntroSectionStatic {
  padding-top: 90px;
  background-color: hsl(0, 0%, 98%);
}

.userPageHeaderStatic {
  width: 100%;
  padding: 8%;
}

.userPageTitleStatic {
  font-size: 3rem;
  margin: 24px 0;
  max-width: 750px;
}

.userPageHeaderTextStatic {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 8%;
}

/****** MQ ******/
@media screen and (min-width: 40em) {
  .userPageIntroSection {
    padding-top: 90px;
    background-color: hsl(0, 0%, 98%);
    height: auto;
  }

  .userPageHeader {
    padding: 6% 8% 8%;
    width: 60%;
  }

  .userPageSubtitle {
    font-size: 1.7rem;
    padding: 2px 24px;
  }

  .userPageTitle {
    font-size: 3rem;
    margin: 24px 0;
    width: 750px;
  }

  .userPageIntroSectionStatic {
    padding: 90px 0;
  }

  .userPageHeaderStatic {
    display: grid;
    grid-template-columns: 60% 40%;
    padding: 0 8% 0;
  }

  .userPageHeaderTextStatic {
    padding-right: 8%;
  }

  .userPageHeaderImageContainerStatic {
    max-height: 600px;
    min-width: 500px;
  }
}

/**********************************************/
/**********************************************/

/* SECTION: FEATURES */
.features {
  margin: 56px 0;
}

.featureContainer {
  display: none;
}

.featureContainerMobile {
  display: flex;
  flex-flow: column wrap;
  padding: 4% 8%;
}

.featureImageContainer {
  width: 100%;
  padding: 24px 0;
}

.featureImage {
  width: 100%;
  border-radius: 16px;
}

.featureBody {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
}

.featureContent {
  width: 100%;
}

.featureTitle {
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 16px;
  color: #12807a;
}

.featureText {
  font-size: 0.9rem;
  margin: 8px 0 16px 0;
}

.featureTextListWithDots {
  list-style-position: inside;
  margin-top: 12px;
  margin-bottom: 12px;
}

.appImage {
  width: 100%;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .features {
    margin: 4% 8%;
  }

  .featureContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 6% 0;
    grid-gap: 8%;
  }

  .featureContainerMobile {
    display: none;
  }

  .featureImageContainer {
    padding: 0;
  }

  .featureContent {
    width: 450px;
  }

  .featureTitle {
    font-size: 1.7rem;
    margin-bottom: 24px;
  }

  .featureText {
    font-size: 1.2rem;
  }
}

/**********************************************/
/**********************************************/

/* PRO BUTTON */

.proButton {
  height: 40px;
  min-width: 180px;
  font-size: 1rem;
  background-color: #16a29a;
  border-radius: 8px;
  padding: 0 3px;
  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.05),
    0 10px 10px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease;
  color: white;
  font-weight: 500;
  white-space: nowrap;
}

.proButton:hover {
  background-color: #7fcbb4;
}

.proContactFormDemoLink {
  color: white;
  text-decoration: none;
  border-bottom: 1px solid white;
}

.proContactFormDemoLink:hover {
  color: hsl(0, 0%, 95%);
  text-decoration: none;
  border-bottom: 1px solid hsl(0, 0%, 95%);
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .proButton {
    height: 50px;
    width: 250px;
    font-size: 1.4rem;
  }
}
/**********************************************/
/**********************************************/

/* PROFILE */

.profileContainer {
  display: flex;
  flex-flow: row wrap;
  padding: 8%;
}

.profileRow {
  background-color: red;
}

.profileGroup {
  max-width: 100%;
  padding: 16px 8px;
}

.profilePhoto {
  width: 100%;
}

.profileBody {
  margin: 8px 0;
}

.profileContent {
  display: flex;
  justify-content: space-between;
  font-weight: 500;
}

.socialMediaIconLink {
  margin-left: 4px;
}

.social-media-icon-small {
  width: 15px;
  height: 15px;
}

.twitter,
.fb,
.linkedin,
.github,
.site {
  fill: hsl(0, 0%, 50%);
  padding-left: 4px;
}

.twitter:hover,
.fb:hover,
.linkedin:hover,
.github:hover,
.site:hover {
  fill: #12807a;
}

.social-media-icons-wrapper {
  text-align: left;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .profileContainer {
    padding: 6% 8% 4%;
  }

  .profileGroup {
    max-width: 33.33%;
  }
}

/**********************************************/
/**********************************************/

/* JOB SECTION */

.jobContainer {
  display: flex;
  flex-flow: column;
  padding: 8%;
  color: white;
  background-color: #16a29a;
}

.jobContainer:hover {
  color: hsl(0, 0%, 95%);
  text-decoration: none;
}

.jobTitle {
  font-size: 2.5rem;
  font-weight: 500;
  margin-bottom: 4px;
}

.jobSubtitle {
  font-size: 1.7rem;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .jobContainer {
    padding: 4% 8%;
    margin: 0 8% 6%;
    cursor: pointer;
  }
}

/**********************************************/
/**********************************************/

/* NEWS */

.newsContainer {
  display: flex;
  flex-direction: column-reverse;
  padding: 0;
}

.newsTwitterContainer {
  margin: 4% 8%;
  height: 100vh;
  overflow: auto;
}

.newsCardContainer {
  display: flex;
  flex-direction: column;
  padding: 4% 8%;
  margin: 40px 0 24px;
  border-radius: 8px;
  color: hsl(0, 0%, 20%);
  cursor: pointer;
  background-color: transparent;
  box-shadow: none;
  transition:
    background-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
  width: 100vw;
}

.newsCardContainer:hover {
  text-decoration: none;
  color: hsl(0, 0%, 20%);
  background-color: white;
  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.05),
    0 10px 10px rgba(0, 0, 0, 0.05);
}

.newsCardPhoto {
  width: 100%;
  border-radius: 8px;
}

.newsContentContainer {
  padding-top: 24px;
}

.newsContentSubtitleContainer {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
}

.newsContentSubtitle {
  color: #16a29a;
  text-transform: uppercase;
}

.newsContentDate {
  color: hsl(0, 0%, 70%);
}

.newsContentTitle {
  font-size: 1.7rem;
  font-weight: 500;
  padding: 8px 0 4px;
  line-height: 1.3;
}

a.newsButton {
  background-color: transparent;
  width: 120px;
  margin-top: 24px;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .newsIntroSection {
    height: auto;
  }

  .newsContainer {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 40px;
    padding: 2% 8% 4%;
  }

  .newsHeader {
    width: 100%;
    padding: 12% 0 6% 8%;
    font-size: 3rem;
    margin-top: 0;
  }

  .newsCardContainer {
    display: grid;
    grid-template-columns: 1.5fr 2fr;
    grid-gap: 32px;
    width: auto;
    padding: 16px;
  }

  .newsContentContainer {
    padding-top: 8px;
  }

  .newsContentTitle {
    font-size: 1.4rem;
    padding: 4px 0;
  }

  a.newsButton {
    margin-top: 16px;
  }
}

/**********************************************/
/**********************************************/

/* JOBS */

.jobsHeaderImage {
  margin-top: 72px;
  width: 100%;
}

.jobsHeaderLogo {
  width: 12%;
  min-width: 60px;
  margin-top: -6%;
}

.jobsTitle {
  font-size: 1.7rem;
  margin: 30px 0;
}

.jobsMain {
  margin: 0 8% 4% 8%;
}

.jobsIntroSection > div {
  margin-bottom: 50px;
}

.jobsIntroBubble {
  position: relative;
  font-size: 1.2rem;
  padding: 20px 60px;
  background-color: hsl(0, 0%, 93%);
}

.jobsIntroBubble::before {
  content: '🔥';
  position: absolute;
  left: 20px;
}

.jobsIntro {
  font-size: 1.2rem;
}

.jobsList > li {
  font-size: 1.2rem;
  margin-bottom: 35px;
}

.jobsCategoryTitle {
  margin-bottom: 30px;
  color: #12807a;
}

.jobLink {
  color: hsl(0, 0%, 20%);
  transition: color 0.2s ease-in-out;
  text-decoration: underline #16a29a;
}

.jobLink:hover {
  text-decoration: none;
  color: #16a29a;
}

.jobLink:focus {
  text-decoration: none;
  color: hsl(0, 0%, 20%);
}

.jobsFooter {
  margin-top: 50px;
  font-size: 1.3rem;
}

.jobDescription > p {
  overflow-wrap: break-word;
}

.jobDescription b {
  color: #12807a;
  font-size: 1.7rem;
  margin-bottom: 16px;
}

.jobDescription > * {
  font-size: 1.2rem;
  margin-bottom: 25px;
}

@media screen and (min-width: 64em) {
  .jobsTitle {
    font-size: 4rem;
    margin: 50px 0;
  }

  .jobsIntroBubble {
    margin: 0 65px;
  }
}

/**********************************************/
/**********************************************/

/* INTERVIEW */

.interviewIntroSection {
  background-color: #12807a;
  padding-top: 72px;
}

.interviewHeader {
  padding: 8%;
  font-weight: 500;
  color: white;
  display: flex;
  flex-flow: column wrap;
}

.interviewSubtitle {
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  margin-bottom: 8px;
  font-weight: 300;
}

.interviewTitle {
  font-size: 1.4rem;
}

.interviewBodySection {
  padding: 8% 8% 2%;
  font-family: Georgia, Cambria, 'Times New Roman', Times, serif;
  font-size: 1.2rem;
}

.interviewBreadcrumb {
  color: hsl(0, 0%, 50%);
  margin-bottom: 8px;
  transition: color 0.2s ease-in-out;
}

.interviewBreadcrumb:hover {
  color: #16a29a;
  text-decoration: none;
}

.interviewSummary {
  background-color: hsl(0, 0%, 95%);
  border-radius: 8px;
  padding: 24px 32px;
  margin: 24px 0;
}

.interviewSnippet {
  margin-bottom: 24px;
}

.interviewQuestion {
  color: #16a29a;
  margin-bottom: 8px;
  font-weight: 600;
}

.interviewAnswer {
  font-weight: 300;
}

.photo {
  width: 100%;
  margin: 16px 0;
  border-radius: 8px;
}

.interviewAnswer p {
  margin: 0 0 12px;
}

.newsImageCaption {
  font-size: 14px;
  font-style: italic;
  margin-bottom: 16px;
}

.pressLink {
  color: white;
}

.pressLink:hover {
  color: hsl(0, 0%, 95%);
  text-decoration: none;
}

.interviewPhotoTextSnippet {
  display: grid;
  grid-gap: 32px;
  padding-bottom: 24px;
}

.interviewPhotoSnippet {
  width: 100%;
}

.interviewNameHighlight {
  font-weight: 600;
}

.interviewThreeCols {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 24px;
  margin: 24px 0;
}

/****** MQ ******/
@media screen and (min-width: 40em) {
  .interviewPhotoTextSnippet {
    grid-template-columns: 1fr 3fr;
  }

  .interviewThreeCols {
    grid-gap: 32px;
    margin: 32px 0;
  }
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .interviewHeader {
    padding: 6% 30% 4%;
  }

  .interviewTitle {
    font-size: 2.1rem;
  }

  .interviewBodySection {
    padding: 4% 30%;
  }
}

/**********************************************/
/**********************************************/

/* ANIMS */

/* Sweep To Right (Secondary Button) */
.secondaryButton {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  color: #16a29a;
  border: 1px solid #16a29a;
  border-radius: 8px;
  width: 120px;
  font-size: 1rem;

  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  position: relative;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.secondaryButton:before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #16a29a;
  border-radius: 6px;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: 0 50%;
  transform-origin: 0 50%;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.secondaryButton:hover,
.secondaryButton:focus,
.secondaryButton:active {
  color: white;
  text-decoration: none;
}

.secondaryButton:hover:before,
.secondaryButton:focus:before,
.secondaryButton:active:before {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .secondaryButton {
    height: 40px;
    width: 150px;
    font-size: 1.2rem;
  }
}

/**********************************************/
/**********************************************/

/* LEGAL MENTION */

.lmContainer {
  background-color: white;
  padding: 8% 8% 8%;
}

.lmSubtitle {
  color: #16a29a;
  font-size: 1.8rem;
  margin-bottom: 50px;
}

.lmPdfColumn {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  max-width: 100%;
  margin-bottom: 50px;
}

.lmPdfLink {
  width: 75px;
  margin-bottom: 15px;
}

.lmPdfLogo {
  width: 100%;
}

@media screen and (min-width: 64em) {
  .lmContainer {
    padding: 4% 8% 4%;
  }

  .lmPdfContainer {
    display: flex;
  }
}

/**********************************************/
/**********************************************/

/* CONTACT */

.contactInputContainer {
  display: flex;
  flex-flow: column wrap;
  margin-bottom: 16px;
}

.contactLabel {
  margin-bottom: 4px;
}

.contactInput {
  border-radius: 8px;
  border: 1px solid hsl(0, 0%, 90%);
  height: 30px;
  padding: 2px 8px;
}

.contactTextArea {
  border-radius: 8px;
  border: 1px solid hsl(0, 0%, 90%);
  height: 60px;
  padding: 2px 8px;
}

.contactSendButton {
  height: 30px;
  border-radius: 8px;
  transition: background-color 0.2s ease-in-out;
  padding: 0 8px;
  border: none;
}

.contactSaveRow {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  color: white;
}

.contactSendButton:hover {
  background-color: #7fcbb4;
}

/**********************************************/
/**********************************************/

/* GDPR */

.gdprWrapper {
  position: fixed;
  bottom: 0;
  z-index: 1000;
  width: 100%;
}

.gdprContainer {
  background-color: hsl(0, 0%, 98%);
  width: 100%;
  display: flex;
  justify-content: center;
  box-shadow:
    rgba(0, 0, 0, 0.05) 0px -14px 28px,
    rgba(0, 0, 0, 0.05) 0px -10px 10px;
}

.gdprBanner {
  padding: 24px;
}

.gdprActionButtonsContainer {
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: flex-end;
  grid-gap: 16px;
}

/**********************************************/
/**********************************************/

/* ACCORDION */

.title {
  padding: 24px 56px 24px 24px;
  cursor: pointer;
  transform: translate3d(0, 0, 0);
  color: #16a29a;
  position: relative;
  background: hsl(0, 0%, 98%);
  margin-bottom: -1px;
  border: 1px solid hsl(0, 0%, 95%);
  text-align: left;
  font-size: 1rem;
  font-weight: 400;
}

.title::after {
  content: '+';
  font-size: 1.4rem;
  transition: transform 0.5s ease-in-out;
  position: absolute;
  right: 32px;
  font-family: monospace;
}

.title.is-expanded {
  transition: background 0.5s;
  background: hsl(0, 0%, 95%);
}

.title.is-expanded::after {
  content: '-';
  transform: rotate(-360deg);
  background: hsl(0, 0%, 95%);
}

.content {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s;
  margin: 0;
  padding: 0;
  border-left: 1px solid hsl(0, 0%, 95%);
  border-right: 1px solid hsl(0, 0%, 95%);
  border-top: 0;
  background: white;
  font-size: 1rem;
}

.content > .contentText {
  padding: 24px;
  margin: 0;
  opacity: 0;
  transition: 0.5s;
}

.content.is-expanded {
  max-height: 500px;
  overflow: hidden;
}

.content.is-expanded > .contentText {
  opacity: 1;
}

/****** MQ ******/

@media screen and (min-width: 64em) {
  .title {
    padding: 32px 80px 32px 32px;
    font-size: 1.4rem;
  }

  .content {
    font-size: 1.4rem;
  }

  .content > .contentText {
    padding: 32px;
  }
}

/**********************************************/
/**********************************************/

/* RATING STAR */

.bz-star {
  font-size: 1.5rem;
  padding: 2px;
  color: #16a29a;
}

@media screen and (min-width: 40em) {
  .bz-star {
    font-size: 1.7rem;
  }
}

/**********************************************/
/**********************************************/

/* CONTENTFUL */

.teamContentful {
  background-color: #f3f6f8;
  width: 100vw;
}

.richText > p {
  overflow-wrap: break-word;
}

.richText > p:empty::before {
  content: ' ';
  white-space: pre;
}

.clientContainer {
  padding: 0 8% 0;
}

.clientContainer > div {
  margin-bottom: 40px;
}

.clientTextHeader {
  text-align: center;
  color: #12807a;
  font-size: 1.9rem;
  padding: 24px 0 15px;
}

.logoList {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.logoImage {
  width: 6rem;
  margin: 25px 45px 0;
}

.testimonyList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 20px;
}

.testimonyBubble {
  position: relative;
  width: 300px;
  text-align: center;
  line-height: 1.4em;
  margin: 40px 0 35px;
  background-color: #fff;
  border: solid #16a29a;
  border-radius: 30px;
  font-family: sans-serif;
  padding: 20px;
  font-size: large;
}

.testimonyBubble:before,
.testimonyBubble:after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
}

.testimonyBubble:before {
  left: 65px;
  bottom: -36px;
  border: 18px solid;
  border-color: #16a29a #16a29a transparent transparent;
}

.testimonyBubble:after {
  left: 67px;
  bottom: -31px;
  border: 16px solid;
  border-color: #fff #fff transparent transparent;
}

.testimonyAuthor {
  margin-left: 100px;
}

.testimonyExtra {
  font-style: italic;
}

@media screen and (min-width: 64em) {
  .clientTextHeader {
    font-size: 2.8rem;
  }
}

/**********************************************/
/**********************************************/

/* WHITE PAPER */

.whitePaperContainer {
  width: 100%;
  margin-bottom: 3rem;
}

.whitePaperContent {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.whitePaperContentLeft {
  margin-right: 10rem;
}

.whitePaperPicture {
  flex: 0 1 900px;
  max-height: 300px;
  margin: 0 auto;
}

.whitePaperList li {
  list-style-type: none;
  margin-bottom: 0;
}

.whitePaperContentRight {
  display: flex;
  flex-direction: column;
  flex: 0 1 500px;
  justify-content: center;
}

.whitePaperModalTitle {
  text-align: center;
}

.whitePaperModalButton {
  text-align: center;
}

/****** MQ ******/
@media screen and (min-width: 64em) {
  .whitePaperContainer {
    grid-template-columns: 1fr 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./css/website.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C,+CAA+C;;AAE/C,mBAAmB;AACnB;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;mCAEiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6CAA6C;;AAE7C;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,eAAe;;EAEf,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,iBAAiB;;AAEjB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;;IAEE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,mBAAmB;;AAEnB;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA,cAAc;;AAEd;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;;EAEf,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,yBAAyB;;AAEzB;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,oBAAoB;;AAEpB;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,aAAa;IACb,wBAAwB;IACxB,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,eAAe;AACf,mBAAmB;AACnB;EACE,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,eAAe;;AAEf;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd;;mCAEiC;EACjC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;AACF;AACA,+CAA+C;AAC/C,+CAA+C;;AAE/C,YAAY;;AAEZ;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,gBAAgB;;AAEhB;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,SAAS;;AAET;EACE,aAAa;EACb,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB;;+BAE6B;EAC7B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB;;mCAEiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,SAAS;;AAET;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,cAAc;;AAEd;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,8DAA8D;EAC9D,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,UAAU;;AAEV,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;;EAEf,sBAAsB;EACtB,iDAAiD;EACjD,yCAAyC;EACzC,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,+BAA+B;EAC/B,uBAAuB;EACvB,sCAAsC;EACtC,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;EACzB,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;;;EAGE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;EAGE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,kBAAkB;;AAElB;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,YAAY;;AAEZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,SAAS;;AAET;EACE,eAAe;EACf,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB;;sCAEoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,cAAc;;AAEd;EACE,4BAA4B;EAC5B,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,UAAU;EACV,sCAAsC;EACtC,uCAAuC;EACvC,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;;AAEjB;EACE;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,gBAAgB;;AAEhB;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,eAAe;;AAEf;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C,+CAA+C;;AAE/C,gBAAgB;;AAEhB;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/**********************************************/\n/**********************************************/\n\n/* SECTION: INTRO */\n.introSection {\n  background-color: hsl(0, 0%, 98%);\n  height: 100%;\n}\n\n.introContainer {\n  padding: 4% 8% 8%;\n}\n\n.introImageWrapper {\n  margin-top: 5%;\n  border-radius: 2rem;\n  overflow: hidden;\n}\n\n.catchphraseContainer {\n  width: 100%;\n}\n\n.catchphrase {\n  font-size: 2.1rem;\n}\n\n.introImage {\n  width: 100%;\n}\n\n.searchBarContainer {\n  width: 100%;\n  height: 40px;\n  color: hsl(0, 0%, 85%);\n  padding: 8px 16px;\n  margin: 8px 0;\n  border: 1px solid hsl(0, 0%, 90%);\n  border-radius: 8px;\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  background-color: white;\n  box-shadow:\n    0 14px 28px rgba(0, 0, 0, 0.05),\n    0 10px 10px rgba(0, 0, 0, 0.05);\n}\n\n.searchIcon {\n  margin-right: 8px;\n}\n\n.mapLink {\n  color: hsl(0, 0%, 65%);\n  font-size: 1rem;\n  transition: color 0.2s ease-in-out;\n  padding-left: 4px;\n}\n\n.mapLink:hover {\n  text-decoration: none;\n  color: #16a29a;\n}\n\n.catchphraseHeader {\n  font-size: 1.7rem;\n  font-weight: 500;\n  line-height: 1.2;\n  max-width: 300px;\n}\n\n/****** Full Size Landing view Component ****/\n\n@media screen and (min-width: 840px) {\n  .introContainer {\n    display: grid;\n    grid-template-columns: 40% 60%;\n    align-items: start;\n    padding: 4% 8%;\n    padding-right: 4%;\n  }\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .catchphraseContainer {\n    justify-content: column wrap;\n  }\n\n  .catchphrase {\n    font-size: 2.1rem;\n    flex-flow: column wrap;\n    padding-top: 26%;\n  }\n\n  .introImageContainer {\n    padding-left: 8%;\n    display: flex;\n    align-items: center;\n  }\n\n  .introImageWrapper {\n    margin-top: 0;\n  }\n\n  .searchBarContainer {\n    height: 50px;\n    font-size: 1.7rem;\n  }\n\n  .mapLink {\n    font-size: 1.2rem;\n  }\n\n  .catchphraseHeader {\n    max-width: none;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* SECTION: MISSION */\n\n.missionBody {\n  padding: 16px 24px;\n  align-items: center;\n  background-color: #16a29a;\n  margin: 8%;\n}\n\n.missionContent {\n  display: grid;\n  grid-template-columns: 100px auto;\n  align-items: center;\n  grid-gap: 16px;\n  padding: 24px 0;\n\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.missionImageContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.missionImage {\n  width: 80px;\n}\n\n.missionContentText {\n  margin-left: 16px;\n}\n\n.missionContentSubtitleText {\n  font-size: 1.2rem;\n  margin-top: 8px;\n  color: white;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .missionBody {\n    display: flex;\n    justify-content: space-evenly;\n    flex-flow: row wrap;\n    align-items: flex-start;\n    padding: 3% 4% 4%;\n    margin: 5% 8%;\n  }\n\n  .missionContent {\n    display: grid;\n    grid-template-columns: none;\n    grid-template-rows: 120px auto;\n    align-items: center;\n    grid-gap: 56px;\n    padding-bottom: 0;\n    text-align: center;\n    width: auto;\n    max-width: 28%;\n    margin: unset;\n  }\n\n  .missionContentText {\n    margin-left: 0;\n  }\n\n  .missionContentSubtitleText {\n    font-size: 1.6rem;\n    margin-top: 0;\n    max-width: 285px;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* SECTION: CTA */\n\n.landingCTAContainer {\n  margin-bottom: 10px;\n}\n\n.mainCTASection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 240px;\n  background-color: #16a29a;\n  padding: 8%;\n}\n\n.mainCTAContainer {\n  min-width: 100%;\n  display: flex;\n  flex-flow: column wrap;\n  align-items: center;\n}\n\n.mainCTATitle {\n  color: #ffffff;\n  font-size: 1.7rem;\n  margin-bottom: 16px;\n  width: 240px;\n  text-align: center;\n}\n\n.mainCTAAction {\n  width: 100%;\n}\n\n.mainCTAText {\n  color: white;\n  font-size: 1.7rem;\n}\n\n.mainCTAText > a {\n  color: white;\n}\n\n.mainCTAText > a:hover {\n  color: hsl(0, 0%, 95%);\n  text-decoration: none;\n}\n\n.formLabel,\n.requiredFormLabel {\n  display: block;\n  margin-bottom: 4px;\n  font-weight: normal;\n}\n\n.requiredFormLabel::after {\n  content: ' *';\n  color: #959595;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .landingCTAContainer {\n    margin-bottom: 10px;\n  }\n  .mainCTASection {\n    height: 350px;\n    padding: 0;\n    margin: 0 8% 6%;\n  }\n\n  .mainCTAContainer {\n    min-width: 400px;\n  }\n\n  .mainCTATitle {\n    font-size: 2.1rem;\n    width: 100%;\n  }\n\n  .formLabel,\n  .requiredFormLabel {\n    margin: 8px 0;\n    font-size: 1.8;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* SECTION: USERS */\n\n.user,\n.team {\n  background-color: #f3f6f8;\n}\n\n.usersSection {\n  background-color: white;\n}\n\n.userTitleText {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #12807a;\n  color: white;\n  font-size: 1.4rem;\n  width: 100%;\n}\n\n/* EACH USER */\n\n.usersContainer {\n  display: none;\n}\n\n.usersContainerMobile {\n  display: block;\n  margin: 0 8% 8%;\n}\n\n.userContainer {\n  display: flex;\n  flex-flow: column wrap;\n  padding: 8% 0;\n}\n\n.userImageContainer {\n  width: 100%;\n  margin-bottom: 32px;\n  display: flex;\n  justify-content: center;\n  border-radius: 2rem;\n  overflow: hidden;\n}\n\n.userBody {\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.userBodyLink:hover {\n  text-decoration: none;\n}\n\n.userBodyContent {\n  width: 100%;\n}\n\n.userTitle {\n  color: white;\n  font-size: 1.2rem;\n  border-radius: 40px;\n  border: 1px solid #16a29a;\n  padding: 4px 16px;\n  background-color: #16a29a;\n}\n\n.userTextHeader {\n  font-size: 1.7rem;\n  margin-bottom: 3rem;\n}\n\n.userTextBody {\n  margin: 4px 0 16px;\n  color: hsl(0, 0%, 10%);\n}\n\n.userTextList {\n  list-style-type: none;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.userTextListWithDots {\n  list-style-position: inside;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.catchphraseSubtitle {\n  margin: 8px 0 16px;\n  color: hsl(0, 0%, 10%);\n  font-size: 1rem;\n\n  background-color: rgba(255, 255, 250, 0.3);\n  border-radius: 5px;\n}\n\n.arrowContainer {\n  border-left: 1px solid #16a29a;\n  margin-left: 8px;\n  padding-left: 8px;\n  display: flex;\n  height: 100%;\n}\n\n.arrowContainer:hover {\n  color: white;\n}\n\n/****** MQ Show Desktop Layout ******/\n@media screen and (min-width: 64em) {\n  .usersContainerMobile {\n    display: none;\n  }\n\n  .usersContainer {\n    display: block;\n    padding-bottom: 80px;\n    background-color: white;\n  }\n\n  .userContainer {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: 4% 8% 2%;\n  }\n\n  .userBodyContent {\n    width: 80%;\n  }\n\n  .userTitle {\n    font-size: 1.7rem;\n    padding: 4px 28px;\n  }\n\n  .userTextHeader {\n    font-size: 2.1rem;\n    line-height: 1.2;\n  }\n\n  .userTextBody {\n    font-size: 1.2rem;\n    margin: 12px 0 24px;\n  }\n\n  .catchphraseSubtitle {\n    font-size: 1.2rem;\n    margin: 12px 0 24px;\n    background: none;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* SECTION: PAGE HEADER */\n\n.pageHeader {\n  margin-top: 72px;\n  padding: 6% 8%;\n  background-color: #16a29a;\n}\n\n.pageHeaderSubtitle {\n  font-size: 1rem;\n  color: hsl(0, 0%, 95%);\n  text-decoration: underline;\n}\n\n.pageHeaderUptitle {\n  font-size: 1.7rem;\n  font-weight: 500;\n  margin-top: 0;\n  color: white;\n}\n\n.pageHeaderTitle {\n  font-size: 1.7rem;\n  font-weight: 500;\n  margin-top: 8px;\n  color: white;\n}\n\n.pageHeaderTitleOnly {\n  font-size: 1.7rem;\n  font-weight: 500;\n  color: white;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .pageHeaderSubtitle {\n    font-size: 1.2rem;\n  }\n\n  .pageHeaderTitle {\n    font-size: 2.5rem;\n  }\n\n  .pageHeaderTitleOnly {\n    font-size: 3rem;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* SECTION: FOOTER */\n\n.footerSection {\n  padding: 8%;\n  background-color: hsl(0, 0%, 98%);\n}\n\n.footerBodyContainer {\n  display: flex;\n  flex-flow: column wrap;\n}\n\n.companyInfoContainer {\n  width: 250px;\n}\n\n.companyInfoTitle {\n  font-size: 2.1rem;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.footerLinkContainer {\n  display: flex;\n  margin-top: 24px;\n}\n\n.footerLinkColumns {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: 12px;\n  width: 100%;\n}\n\n.footerLinkGroup {\n  display: grid;\n}\n\n.footerLinkTitle {\n  font-weight: 700;\n}\n\n.footerBottomContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid hsl(0, 0%, 90%);\n}\n\n.footerBottomCopyright {\n  display: grid;\n  grid-template-rows: auto auto auto;\n  grid-gap: 4px;\n}\n\n.socialButtonsContainer {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: 8px;\n}\n\n.textLink {\n  color: hsl(0, 0%, 20%);\n  transition: color 0.2s ease-in-out;\n  cursor: pointer;\n}\n\n.textLink:hover {\n  text-decoration: none;\n  color: #16a29a;\n}\n\n.textLink:focus {\n  text-decoration: none;\n  color: hsl(0, 0%, 20%);\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.footerContactButton {\n  background-color: #16a29a;\n  border-radius: 8px;\n  color: white;\n  padding: 5px 10px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.footerContactButton:hover {\n  background-color: #7fcbb4;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .footerSection {\n    padding: 4% 8%;\n  }\n\n  .footerBodyContainer {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n  }\n\n  .footerLinkContainer {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 0;\n  }\n\n  .footerLinkGroup {\n    display: grid;\n    grid-gap: 8px;\n  }\n\n  .footerBottomCopyright {\n    display: grid;\n    grid-template-rows: none;\n    grid-template-columns: auto auto auto;\n    grid-gap: 16px;\n  }\n\n  .footerContactButton {\n    font-size: 1rem;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* PROMOTEURS */\n/* SECTION: INTRO */\n.userPageIntroSection {\n  padding-top: 90px;\n  background-color: hsl(0, 0%, 98%);\n  height: 100vh;\n}\n\n.userPageHeader {\n  width: 100%;\n  padding: 8%;\n}\n\n.userPageSubtitle {\n  color: #12807a;\n  font-size: 1.2rem;\n  width: fit-content;\n  border: 1px solid #12807a;\n  border-radius: 40px;\n  padding: 4px 24px;\n}\n\n.userPageTitle {\n  font-size: 1.7rem;\n  margin: 24px 0 8px;\n  line-height: 1.3;\n}\n\n.userPageIntroSectionStatic {\n  padding-top: 90px;\n  background-color: hsl(0, 0%, 98%);\n}\n\n.userPageHeaderStatic {\n  width: 100%;\n  padding: 8%;\n}\n\n.userPageTitleStatic {\n  font-size: 3rem;\n  margin: 24px 0;\n  max-width: 750px;\n}\n\n.userPageHeaderTextStatic {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-bottom: 8%;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 40em) {\n  .userPageIntroSection {\n    padding-top: 90px;\n    background-color: hsl(0, 0%, 98%);\n    height: auto;\n  }\n\n  .userPageHeader {\n    padding: 6% 8% 8%;\n    width: 60%;\n  }\n\n  .userPageSubtitle {\n    font-size: 1.7rem;\n    padding: 2px 24px;\n  }\n\n  .userPageTitle {\n    font-size: 3rem;\n    margin: 24px 0;\n    width: 750px;\n  }\n\n  .userPageIntroSectionStatic {\n    padding: 90px 0;\n  }\n\n  .userPageHeaderStatic {\n    display: grid;\n    grid-template-columns: 60% 40%;\n    padding: 0 8% 0;\n  }\n\n  .userPageHeaderTextStatic {\n    padding-right: 8%;\n  }\n\n  .userPageHeaderImageContainerStatic {\n    max-height: 600px;\n    min-width: 500px;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* SECTION: FEATURES */\n.features {\n  margin: 56px 0;\n}\n\n.featureContainer {\n  display: none;\n}\n\n.featureContainerMobile {\n  display: flex;\n  flex-flow: column wrap;\n  padding: 4% 8%;\n}\n\n.featureImageContainer {\n  width: 100%;\n  padding: 24px 0;\n}\n\n.featureImage {\n  width: 100%;\n  border-radius: 16px;\n}\n\n.featureBody {\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.featureContent {\n  width: 100%;\n}\n\n.featureTitle {\n  font-size: 1.2rem;\n  font-weight: 500;\n  margin-bottom: 16px;\n  color: #12807a;\n}\n\n.featureText {\n  font-size: 0.9rem;\n  margin: 8px 0 16px 0;\n}\n\n.featureTextListWithDots {\n  list-style-position: inside;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.appImage {\n  width: 100%;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .features {\n    margin: 4% 8%;\n  }\n\n  .featureContainer {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: 6% 0;\n    grid-gap: 8%;\n  }\n\n  .featureContainerMobile {\n    display: none;\n  }\n\n  .featureImageContainer {\n    padding: 0;\n  }\n\n  .featureContent {\n    width: 450px;\n  }\n\n  .featureTitle {\n    font-size: 1.7rem;\n    margin-bottom: 24px;\n  }\n\n  .featureText {\n    font-size: 1.2rem;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* PRO BUTTON */\n\n.proButton {\n  height: 40px;\n  min-width: 180px;\n  font-size: 1rem;\n  background-color: #16a29a;\n  border-radius: 8px;\n  padding: 0 3px;\n  box-shadow:\n    0 14px 28px rgba(0, 0, 0, 0.05),\n    0 10px 10px rgba(0, 0, 0, 0.05);\n  transition: background-color 0.2s ease;\n  color: white;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.proButton:hover {\n  background-color: #7fcbb4;\n}\n\n.proContactFormDemoLink {\n  color: white;\n  text-decoration: none;\n  border-bottom: 1px solid white;\n}\n\n.proContactFormDemoLink:hover {\n  color: hsl(0, 0%, 95%);\n  text-decoration: none;\n  border-bottom: 1px solid hsl(0, 0%, 95%);\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .proButton {\n    height: 50px;\n    width: 250px;\n    font-size: 1.4rem;\n  }\n}\n/**********************************************/\n/**********************************************/\n\n/* PROFILE */\n\n.profileContainer {\n  display: flex;\n  flex-flow: row wrap;\n  padding: 8%;\n}\n\n.profileRow {\n  background-color: red;\n}\n\n.profileGroup {\n  max-width: 100%;\n  padding: 16px 8px;\n}\n\n.profilePhoto {\n  width: 100%;\n}\n\n.profileBody {\n  margin: 8px 0;\n}\n\n.profileContent {\n  display: flex;\n  justify-content: space-between;\n  font-weight: 500;\n}\n\n.socialMediaIconLink {\n  margin-left: 4px;\n}\n\n.social-media-icon-small {\n  width: 15px;\n  height: 15px;\n}\n\n.twitter,\n.fb,\n.linkedin,\n.github,\n.site {\n  fill: hsl(0, 0%, 50%);\n  padding-left: 4px;\n}\n\n.twitter:hover,\n.fb:hover,\n.linkedin:hover,\n.github:hover,\n.site:hover {\n  fill: #12807a;\n}\n\n.social-media-icons-wrapper {\n  text-align: left;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .profileContainer {\n    padding: 6% 8% 4%;\n  }\n\n  .profileGroup {\n    max-width: 33.33%;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* JOB SECTION */\n\n.jobContainer {\n  display: flex;\n  flex-flow: column;\n  padding: 8%;\n  color: white;\n  background-color: #16a29a;\n}\n\n.jobContainer:hover {\n  color: hsl(0, 0%, 95%);\n  text-decoration: none;\n}\n\n.jobTitle {\n  font-size: 2.5rem;\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.jobSubtitle {\n  font-size: 1.7rem;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .jobContainer {\n    padding: 4% 8%;\n    margin: 0 8% 6%;\n    cursor: pointer;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* NEWS */\n\n.newsContainer {\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 0;\n}\n\n.newsTwitterContainer {\n  margin: 4% 8%;\n  height: 100vh;\n  overflow: auto;\n}\n\n.newsCardContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 4% 8%;\n  margin: 40px 0 24px;\n  border-radius: 8px;\n  color: hsl(0, 0%, 20%);\n  cursor: pointer;\n  background-color: transparent;\n  box-shadow: none;\n  transition:\n    background-color 0.2s ease-in-out,\n    box-shadow 0.2s ease-in-out;\n  width: 100vw;\n}\n\n.newsCardContainer:hover {\n  text-decoration: none;\n  color: hsl(0, 0%, 20%);\n  background-color: white;\n  box-shadow:\n    0 14px 28px rgba(0, 0, 0, 0.05),\n    0 10px 10px rgba(0, 0, 0, 0.05);\n}\n\n.newsCardPhoto {\n  width: 100%;\n  border-radius: 8px;\n}\n\n.newsContentContainer {\n  padding-top: 24px;\n}\n\n.newsContentSubtitleContainer {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n}\n\n.newsContentSubtitle {\n  color: #16a29a;\n  text-transform: uppercase;\n}\n\n.newsContentDate {\n  color: hsl(0, 0%, 70%);\n}\n\n.newsContentTitle {\n  font-size: 1.7rem;\n  font-weight: 500;\n  padding: 8px 0 4px;\n  line-height: 1.3;\n}\n\na.newsButton {\n  background-color: transparent;\n  width: 120px;\n  margin-top: 24px;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .newsIntroSection {\n    height: auto;\n  }\n\n  .newsContainer {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    grid-gap: 40px;\n    padding: 2% 8% 4%;\n  }\n\n  .newsHeader {\n    width: 100%;\n    padding: 12% 0 6% 8%;\n    font-size: 3rem;\n    margin-top: 0;\n  }\n\n  .newsCardContainer {\n    display: grid;\n    grid-template-columns: 1.5fr 2fr;\n    grid-gap: 32px;\n    width: auto;\n    padding: 16px;\n  }\n\n  .newsContentContainer {\n    padding-top: 8px;\n  }\n\n  .newsContentTitle {\n    font-size: 1.4rem;\n    padding: 4px 0;\n  }\n\n  a.newsButton {\n    margin-top: 16px;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* JOBS */\n\n.jobsHeaderImage {\n  margin-top: 72px;\n  width: 100%;\n}\n\n.jobsHeaderLogo {\n  width: 12%;\n  min-width: 60px;\n  margin-top: -6%;\n}\n\n.jobsTitle {\n  font-size: 1.7rem;\n  margin: 30px 0;\n}\n\n.jobsMain {\n  margin: 0 8% 4% 8%;\n}\n\n.jobsIntroSection > div {\n  margin-bottom: 50px;\n}\n\n.jobsIntroBubble {\n  position: relative;\n  font-size: 1.2rem;\n  padding: 20px 60px;\n  background-color: hsl(0, 0%, 93%);\n}\n\n.jobsIntroBubble::before {\n  content: '🔥';\n  position: absolute;\n  left: 20px;\n}\n\n.jobsIntro {\n  font-size: 1.2rem;\n}\n\n.jobsList > li {\n  font-size: 1.2rem;\n  margin-bottom: 35px;\n}\n\n.jobsCategoryTitle {\n  margin-bottom: 30px;\n  color: #12807a;\n}\n\n.jobLink {\n  color: hsl(0, 0%, 20%);\n  transition: color 0.2s ease-in-out;\n  text-decoration: underline #16a29a;\n}\n\n.jobLink:hover {\n  text-decoration: none;\n  color: #16a29a;\n}\n\n.jobLink:focus {\n  text-decoration: none;\n  color: hsl(0, 0%, 20%);\n}\n\n.jobsFooter {\n  margin-top: 50px;\n  font-size: 1.3rem;\n}\n\n.jobDescription > p {\n  overflow-wrap: break-word;\n}\n\n.jobDescription b {\n  color: #12807a;\n  font-size: 1.7rem;\n  margin-bottom: 16px;\n}\n\n.jobDescription > * {\n  font-size: 1.2rem;\n  margin-bottom: 25px;\n}\n\n@media screen and (min-width: 64em) {\n  .jobsTitle {\n    font-size: 4rem;\n    margin: 50px 0;\n  }\n\n  .jobsIntroBubble {\n    margin: 0 65px;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* INTERVIEW */\n\n.interviewIntroSection {\n  background-color: #12807a;\n  padding-top: 72px;\n}\n\n.interviewHeader {\n  padding: 8%;\n  font-weight: 500;\n  color: white;\n  display: flex;\n  flex-flow: column wrap;\n}\n\n.interviewSubtitle {\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  font-weight: 300;\n}\n\n.interviewTitle {\n  font-size: 1.4rem;\n}\n\n.interviewBodySection {\n  padding: 8% 8% 2%;\n  font-family: Georgia, Cambria, 'Times New Roman', Times, serif;\n  font-size: 1.2rem;\n}\n\n.interviewBreadcrumb {\n  color: hsl(0, 0%, 50%);\n  margin-bottom: 8px;\n  transition: color 0.2s ease-in-out;\n}\n\n.interviewBreadcrumb:hover {\n  color: #16a29a;\n  text-decoration: none;\n}\n\n.interviewSummary {\n  background-color: hsl(0, 0%, 95%);\n  border-radius: 8px;\n  padding: 24px 32px;\n  margin: 24px 0;\n}\n\n.interviewSnippet {\n  margin-bottom: 24px;\n}\n\n.interviewQuestion {\n  color: #16a29a;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.interviewAnswer {\n  font-weight: 300;\n}\n\n.photo {\n  width: 100%;\n  margin: 16px 0;\n  border-radius: 8px;\n}\n\n.interviewAnswer p {\n  margin: 0 0 12px;\n}\n\n.newsImageCaption {\n  font-size: 14px;\n  font-style: italic;\n  margin-bottom: 16px;\n}\n\n.pressLink {\n  color: white;\n}\n\n.pressLink:hover {\n  color: hsl(0, 0%, 95%);\n  text-decoration: none;\n}\n\n.interviewPhotoTextSnippet {\n  display: grid;\n  grid-gap: 32px;\n  padding-bottom: 24px;\n}\n\n.interviewPhotoSnippet {\n  width: 100%;\n}\n\n.interviewNameHighlight {\n  font-weight: 600;\n}\n\n.interviewThreeCols {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: 24px;\n  margin: 24px 0;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 40em) {\n  .interviewPhotoTextSnippet {\n    grid-template-columns: 1fr 3fr;\n  }\n\n  .interviewThreeCols {\n    grid-gap: 32px;\n    margin: 32px 0;\n  }\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .interviewHeader {\n    padding: 6% 30% 4%;\n  }\n\n  .interviewTitle {\n    font-size: 2.1rem;\n  }\n\n  .interviewBodySection {\n    padding: 4% 30%;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* ANIMS */\n\n/* Sweep To Right (Secondary Button) */\n.secondaryButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  color: #16a29a;\n  border: 1px solid #16a29a;\n  border-radius: 8px;\n  width: 120px;\n  font-size: 1rem;\n\n  vertical-align: middle;\n  -webkit-transform: perspective(1px) translateZ(0);\n  transform: perspective(1px) translateZ(0);\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0);\n  position: relative;\n  -webkit-transition-property: color;\n  transition-property: color;\n  -webkit-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n}\n\n.secondaryButton:before {\n  content: '';\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #16a29a;\n  border-radius: 6px;\n  -webkit-transform: scaleX(0);\n  transform: scaleX(0);\n  -webkit-transform-origin: 0 50%;\n  transform-origin: 0 50%;\n  -webkit-transition-property: transform;\n  transition-property: transform;\n  -webkit-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  -webkit-transition-timing-function: ease-out;\n  transition-timing-function: ease-out;\n}\n\n.secondaryButton:hover,\n.secondaryButton:focus,\n.secondaryButton:active {\n  color: white;\n  text-decoration: none;\n}\n\n.secondaryButton:hover:before,\n.secondaryButton:focus:before,\n.secondaryButton:active:before {\n  -webkit-transform: scaleX(1);\n  transform: scaleX(1);\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .secondaryButton {\n    height: 40px;\n    width: 150px;\n    font-size: 1.2rem;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* LEGAL MENTION */\n\n.lmContainer {\n  background-color: white;\n  padding: 8% 8% 8%;\n}\n\n.lmSubtitle {\n  color: #16a29a;\n  font-size: 1.8rem;\n  margin-bottom: 50px;\n}\n\n.lmPdfColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 300px;\n  max-width: 100%;\n  margin-bottom: 50px;\n}\n\n.lmPdfLink {\n  width: 75px;\n  margin-bottom: 15px;\n}\n\n.lmPdfLogo {\n  width: 100%;\n}\n\n@media screen and (min-width: 64em) {\n  .lmContainer {\n    padding: 4% 8% 4%;\n  }\n\n  .lmPdfContainer {\n    display: flex;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* CONTACT */\n\n.contactInputContainer {\n  display: flex;\n  flex-flow: column wrap;\n  margin-bottom: 16px;\n}\n\n.contactLabel {\n  margin-bottom: 4px;\n}\n\n.contactInput {\n  border-radius: 8px;\n  border: 1px solid hsl(0, 0%, 90%);\n  height: 30px;\n  padding: 2px 8px;\n}\n\n.contactTextArea {\n  border-radius: 8px;\n  border: 1px solid hsl(0, 0%, 90%);\n  height: 60px;\n  padding: 2px 8px;\n}\n\n.contactSendButton {\n  height: 30px;\n  border-radius: 8px;\n  transition: background-color 0.2s ease-in-out;\n  padding: 0 8px;\n  border: none;\n}\n\n.contactSaveRow {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  color: white;\n}\n\n.contactSendButton:hover {\n  background-color: #7fcbb4;\n}\n\n/**********************************************/\n/**********************************************/\n\n/* GDPR */\n\n.gdprWrapper {\n  position: fixed;\n  bottom: 0;\n  z-index: 1000;\n  width: 100%;\n}\n\n.gdprContainer {\n  background-color: hsl(0, 0%, 98%);\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  box-shadow:\n    rgba(0, 0, 0, 0.05) 0px -14px 28px,\n    rgba(0, 0, 0, 0.05) 0px -10px 10px;\n}\n\n.gdprBanner {\n  padding: 24px;\n}\n\n.gdprActionButtonsContainer {\n  width: 100%;\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-content: flex-end;\n  grid-gap: 16px;\n}\n\n/**********************************************/\n/**********************************************/\n\n/* ACCORDION */\n\n.title {\n  padding: 24px 56px 24px 24px;\n  cursor: pointer;\n  transform: translate3d(0, 0, 0);\n  color: #16a29a;\n  position: relative;\n  background: hsl(0, 0%, 98%);\n  margin-bottom: -1px;\n  border: 1px solid hsl(0, 0%, 95%);\n  text-align: left;\n  font-size: 1rem;\n  font-weight: 400;\n}\n\n.title::after {\n  content: '+';\n  font-size: 1.4rem;\n  transition: transform 0.5s ease-in-out;\n  position: absolute;\n  right: 32px;\n  font-family: monospace;\n}\n\n.title.is-expanded {\n  transition: background 0.5s;\n  background: hsl(0, 0%, 95%);\n}\n\n.title.is-expanded::after {\n  content: '-';\n  transform: rotate(-360deg);\n  background: hsl(0, 0%, 95%);\n}\n\n.content {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.5s;\n  margin: 0;\n  padding: 0;\n  border-left: 1px solid hsl(0, 0%, 95%);\n  border-right: 1px solid hsl(0, 0%, 95%);\n  border-top: 0;\n  background: white;\n  font-size: 1rem;\n}\n\n.content > .contentText {\n  padding: 24px;\n  margin: 0;\n  opacity: 0;\n  transition: 0.5s;\n}\n\n.content.is-expanded {\n  max-height: 500px;\n  overflow: hidden;\n}\n\n.content.is-expanded > .contentText {\n  opacity: 1;\n}\n\n/****** MQ ******/\n\n@media screen and (min-width: 64em) {\n  .title {\n    padding: 32px 80px 32px 32px;\n    font-size: 1.4rem;\n  }\n\n  .content {\n    font-size: 1.4rem;\n  }\n\n  .content > .contentText {\n    padding: 32px;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* RATING STAR */\n\n.bz-star {\n  font-size: 1.5rem;\n  padding: 2px;\n  color: #16a29a;\n}\n\n@media screen and (min-width: 40em) {\n  .bz-star {\n    font-size: 1.7rem;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* CONTENTFUL */\n\n.teamContentful {\n  background-color: #f3f6f8;\n  width: 100vw;\n}\n\n.richText > p {\n  overflow-wrap: break-word;\n}\n\n.richText > p:empty::before {\n  content: ' ';\n  white-space: pre;\n}\n\n.clientContainer {\n  padding: 0 8% 0;\n}\n\n.clientContainer > div {\n  margin-bottom: 40px;\n}\n\n.clientTextHeader {\n  text-align: center;\n  color: #12807a;\n  font-size: 1.9rem;\n  padding: 24px 0 15px;\n}\n\n.logoList {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.logoImage {\n  width: 6rem;\n  margin: 25px 45px 0;\n}\n\n.testimonyList {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin-bottom: 20px;\n}\n\n.testimonyBubble {\n  position: relative;\n  width: 300px;\n  text-align: center;\n  line-height: 1.4em;\n  margin: 40px 0 35px;\n  background-color: #fff;\n  border: solid #16a29a;\n  border-radius: 30px;\n  font-family: sans-serif;\n  padding: 20px;\n  font-size: large;\n}\n\n.testimonyBubble:before,\n.testimonyBubble:after {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n}\n\n.testimonyBubble:before {\n  left: 65px;\n  bottom: -36px;\n  border: 18px solid;\n  border-color: #16a29a #16a29a transparent transparent;\n}\n\n.testimonyBubble:after {\n  left: 67px;\n  bottom: -31px;\n  border: 16px solid;\n  border-color: #fff #fff transparent transparent;\n}\n\n.testimonyAuthor {\n  margin-left: 100px;\n}\n\n.testimonyExtra {\n  font-style: italic;\n}\n\n@media screen and (min-width: 64em) {\n  .clientTextHeader {\n    font-size: 2.8rem;\n  }\n}\n\n/**********************************************/\n/**********************************************/\n\n/* WHITE PAPER */\n\n.whitePaperContainer {\n  width: 100%;\n  margin-bottom: 3rem;\n}\n\n.whitePaperContent {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n}\n\n.whitePaperContentLeft {\n  margin-right: 10rem;\n}\n\n.whitePaperPicture {\n  flex: 0 1 900px;\n  max-height: 300px;\n  margin: 0 auto;\n}\n\n.whitePaperList li {\n  list-style-type: none;\n  margin-bottom: 0;\n}\n\n.whitePaperContentRight {\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 500px;\n  justify-content: center;\n}\n\n.whitePaperModalTitle {\n  text-align: center;\n}\n\n.whitePaperModalButton {\n  text-align: center;\n}\n\n/****** MQ ******/\n@media screen and (min-width: 64em) {\n  .whitePaperContainer {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
